import config from "config";
import { createGlobalStyle } from "styled-components/macro";

export const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: ObjectSans;
    src: url('${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Regular.eot?#iefix') format('embedded-opentype'),
    url(${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Regular.woff) format('woff'),
    url(${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Regular.woff2) format('woff2');
    font-weight: 400;
  }

  @font-face {
    font-family: ObjectSans;
    src: url('${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Medium.eot?#iefix') format('embedded-opentype'),
    url(${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Medium.woff) format('woff'),
    url(${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Medium.woff2) format('woff2');
    font-weight: 500;
  }

  @font-face {
    font-family: ObjectSans;
    src: url('${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Heavy.eot?#iefix') format('embedded-opentype'),
    url(${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Heavy.woff) format('woff'),
    url(${config.RESOURCE_ORIGIN}/fonts/ObjectSans-Heavy.woff2) format('woff2');
    font-weight: 900;
  }
`;
